export default {
  // Tab 標籤
  transactionAnalysis: "交易分析",
  keyTransactions: "關鍵交易",
  counterparty: "交易對手(USDT)",
  transactionDetails: "主幣轉賬",
  tokenTransfer: "代幣轉賬",
  otherInfo: "其他信息",
  assets: "資產",

  // 統計信息
  total: "共計",
  totalData: "條數據",

  // 搜索和篩選
  searchCounterpartyAddress: "搜索交易對手地址",
  minAmount: "最小數量",
  maxAmount: "最大數量",
  minCount: "最少次數",
  maxCount: "最大次數",
  pleaseSelect: "請選擇",
  pleaseSelectCurrency: "請選擇幣種",
  pleaseSelectCurrencyFirst: "請先選擇幣種",

  // 日期選擇
  startDate: "開始日期",
  endDate: "結束日期",

  // 按鈕
  reset: "重置",
  query: "查詢",

  // 驗證提示
  maxAmountError: "最大金額需≥最小金額",
  maxCountError: "最大次數需≥最小次數",

  // 選項
  senderReceiver: "發送方/接收方",
  sender: "發送方",
  receiver: "接收方",

  // 復選框
  hideZeroTransactions: "隱藏數量為0的交易",

  // 消息提示
  alreadyCurrentPage: "已經是當前地址詳情頁!",

  // 文件名
  dataDetailsFileName: "數據明細",
};
